module.exports = __webpack_public_path__ + "img/Img_3181.adf0a8aa.jpg";